import LiveProduct from "./LiveProduct";
import { isNuvemshopEnabled } from "@/services/nuvemshop";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import FeaturesBar from "@/components/feature/FeaturesBar";
import CartDrawer from "@/components/feature/CartDrawer";
import Breadcrumb from "@/pages/home/components/Breadcrumb";
import ProductGallery from "@/pages/product/components/ProductGallery";
import ProductInfo from "@/pages/product/components/ProductInfo";
import ProductTabs from "@/pages/product/components/ProductTabs";
import RelatedProducts from "@/pages/product/components/RelatedProducts";
import { products, type Product } from "@/mocks/products";
import { productDetails } from "@/mocks/productDetails";
import { useCart } from "@/context/CartContext";

export default function ProductDetailPage() { return isNuvemshopEnabled() ? <LiveProduct /> : <DemoProduct />; }
function DemoProduct() {
  const { id } = useParams();
  const { addItem, openCart } = useCart();
  const [toast, setToast] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [id]);

  const product = products.find((item) => String(item.id) === id);
  const detail = productDetails.find((item) => item.id === product?.id);

  const handleAdd = (item: Product, quantity = 1) => {
    addItem({ id: item.id, name: item.name, price: item.price, image: item.image, variantId: item.variantId }, quantity);
    openCart();
    setToast(`${item.name} adicionado à sacola`);
    window.setTimeout(() => setToast(null), 2600);
  };

  const handleBuyNow = (item: Product, quantity = 1) => {
    addItem({ id: item.id, name: item.name, price: item.price, image: item.image, variantId: item.variantId }, quantity);
    openCart();
  };

  if (!product || !detail) {
    return (
      <div className="flex min-h-screen flex-col bg-background-50">
        <Header />
        <main className="mx-auto flex w-full max-w-none flex-1 flex-col items-center justify-center px-4 py-24 text-center md:px-6">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-primary-500">
            <i className="ri-emotion-sad-line text-3xl"></i>
          </span>
          <h1 className="mt-5 font-heading text-3xl font-semibold text-foreground-950">
            Produto não encontrado
          </h1>
          <p className="mt-2 text-sm text-foreground-600">
            A peça que você procura pode ter saído do catálogo.
          </p>
          <Link
            to="/"
            className="mt-6 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold uppercase tracking-wide text-background-50 transition-colors hover:bg-primary-600"
          >
            Voltar para a loja
          </Link>
        </main>
        <Footer />
      </div>
    );
  }

  const gallery = [product.image, ...detail.extras];
  const related = products.filter((item) => item.id !== product.id).slice(0, 4);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <Breadcrumb current={product.name} parents={[{ label: "Colares", href: "/" }]} />

      <main className="mx-auto w-full max-w-none flex-1 px-4 pb-16 pt-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <ProductGallery images={gallery} alt={product.name} />
          <ProductInfo
            product={product}
            detail={detail}
            onAddToCart={(item, quantity) => handleAdd(item, quantity)}
            onBuyNow={(item, quantity) => handleBuyNow(item, quantity)}
          />
        </div>

        <ProductTabs detail={detail} />

        <RelatedProducts products={related} onAddToCart={(item) => handleAdd(item)} />
      </main>

      <FeaturesBar />
      <Footer />
      <CartDrawer />

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-[60] flex -translate-x-1/2 items-center gap-3 rounded-lg bg-foreground-950 px-5 py-3 text-sm text-background-50 shadow-lg">
          <span className="flex h-5 w-5 items-center justify-center text-primary-400">
            <i className="ri-checkbox-circle-line text-lg"></i>
          </span>
          {toast}
        </div>
      )}
    </div>
  );
}
